export default {
  "create": "បង្កើតថ្មី",
  "of": "នៃ",
  "clearFilter": "លុប",
  "archived": "លុបបណ្ណោះអាសន្ន",
  "containText": "ស្វែងរក...",
  "loading": "កំពុងដំណេីរការ...",
};
